import React from 'react'
import styled from 'styled-components'
import { formatTicketDateTime } from './utils'

const Wrap = styled.span`
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
`

const LevelPill = styled.span`
    display: inline-flex;
    gap: 3px;
    align-items: center;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.02em;
    background: ${p => {
        if (p.$level >= 2) return '#ffedd5'
        if (p.$level >= 1) return '#fef9c3'
        return '#f3f4f6'
    }};
    color: ${p => {
        if (p.$level >= 2) return '#c2410c'
        if (p.$level >= 1) return '#854d0e'
        return '#6b7280'
    }};
`

const Dot = styled.span`
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
    opacity: ${p => (p.$on ? 1 : 0.5)};
    display: inline-block;
`

const Chip = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    background: ${p => (p.$kind === 'overdue' ? '#fecaca' : '#fef9c3')};
    color: ${p => (p.$kind === 'overdue' ? '#dc2626' : '#854d0e')};
`

const TICKET_STATUS_ESCALATED = 7

export const getEscalationLevel = ticket => {
    const n = Number(ticket?.escalationLevel)
    if (!Number.isFinite(n) || n < 0) return 0
    return n
}

export const isTicketOverdue = ticket => {
    const v = ticket?.isOverdue
    return v === true || v === 1 || v === '1'
}

export const isTicketReminded = ticket => {
    const level = getEscalationLevel(ticket)
    const statusId = Number(ticket?.statusId)
    return level >= 1 && statusId !== TICKET_STATUS_ESCALATED
}

export const EscalationLevelPill = ({ level }) => {
    const n = Math.max(0, Number(level) || 0)
    const shown = n >= 2 ? 2 : n
    return (
        <LevelPill $level={n} title={`Escalation level ${n}`}>
            <Dot $on={shown >= 1} />
            <Dot $on={shown >= 2} /> L{n >= 2 ? 2 : n}
        </LevelPill>
    )
}

export const EscalationCell = ({ ticket }) => {
    const level = getEscalationLevel(ticket)
    const overdue = isTicketOverdue(ticket)
    const reminded = isTicketReminded(ticket)
    const lastOn = ticket?.lastEscalationOn
        ? formatTicketDateTime(ticket.lastEscalationOn)
        : ''

    return (
        <Wrap>
            <EscalationLevelPill level={level} />
            {overdue && <Chip $kind="overdue">OVERDUE</Chip>}
            {reminded && (
                <Chip
                    $kind="reminded"
                    title={lastOn ? `Last reminder: ${lastOn}` : 'Reminded'}
                >
                    REMINDED
                </Chip>
            )}
        </Wrap>
    )
}

export const EscalationStatusChips = ({ ticket }) => (
    <Wrap>
        {isTicketOverdue(ticket) && <Chip $kind="overdue">OVERDUE</Chip>}
        {isTicketReminded(ticket) && <Chip $kind="reminded">REMINDED</Chip>}
    </Wrap>
)
